<template>
    <div class="index">
        <HeadNav></HeadNav>
        <LeftMenu></LeftMenu>
        <Subject></Subject>
        <div :class="'rightContainer ' + (isCollapse ? 'spread' : '')">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import HeadNav from '../components/HeadNav'
import LeftMenu from '../components/LeftMenu'
import Subject from '../components/Subject'

export default {
    name: 'index',
    components: {
        HeadNav,
        LeftMenu,
        Subject
    },
    computed: {
        isCollapse () {
            return this.$store.state.isCollapse
        }
    }
}
</script>
<style scoped lang="scss">
    .index {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .rightContainer {
        position: relative;
        top: 0;
        left: 220px;
        width: calc(100% - 220px);
        height: calc(100% - 100px);
        overflow: auto;
        background-color: #f5f5f5;
        padding: 20px 40px;
        &.spread {
            left: 60px;
            width: calc(100% - 60px);
        }
    }
</style>
